export default {
	methods: {
		forceFileDownload(response) {
			const contentDisposition = response.headers['content-disposition'];
			const filename = contentDisposition.match(/\"(?<filename>.*)\"/)[1];

			const url = window.URL.createObjectURL(new Blob([response.data]));

			const link = document.createElement('a');
			link.href = url;

			link.setAttribute('download', filename);

			document.body.appendChild(link);

			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		},
		forceFileDownloadFromUrl(url) {
			const filename = url.split('/').pop();

			const link = document.createElement('a');
			link.href = url;

			link.setAttribute('download', filename);

			document.body.appendChild(link);

			link.click();
			link.remove();
		},
	},
};
